import React from 'react';
import { ArrowLeftIcon } from '@fiverr-private/visuals';
import { Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { TextButton } from '@fiverr-private/button';
import { translate } from '@fiverr-private/i18n-react';

const ButtonWithArrowLeft = ({ onBack }: { onBack?: () => void }) => (
    <TextButton onClick={onBack}>
        <Stack alignItems={'center'} gap={'1.5'}>
            <ArrowLeftIcon size={'md'} color={'grey_900'} />
            <Text color={'inherit'}>{translate('compliance.back')}</Text>
        </Stack>
    </TextButton>
);

export default ButtonWithArrowLeft;
